module.exports = __webpack_public_path__ + "static/media/eyetracking.39697b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/eyetracking.png
// module id = 396
// module chunks = 1